// extracted by mini-css-extract-plugin
module.exports = {"popover":"popover_Popover_3mWkE","show-popover":"show-popover_Popover_2h1C0","close-box":"close-box_Popover_3W7XD"};